(() => {
const quotePath = '/pages/book-your-event-today';
const bookingLabel = /^(book\s+now|book\s+(your|an?)\s+event|get\s+a\s+quote|let[’']?s\s+get\s+a\s+quote)[!.]?$/i;
function updateQuoteButtons() {
document.querySelectorAll('a,button,input[type="button"],input[type="submit"]').forEach(element => {
const label = (element.matches('input') ? element.value : element.textContent).trim().replace(/\s+/g,' ');
const href = element.getAttribute('href') || '';
const isBookingLink = element.tagName === 'A' && (/^\/pages\/(book-your-event-today|book-now)(?:[?#]|$)/.test(href) || /(?:form\.)?jotform\.com\//i.test(href));
if (!isBookingLink && !bookingLabel.test(label)) return;
if (element.tagName === 'A') {
if (element.getAttribute('href') !== quotePath) element.setAttribute('href', quotePath);
if (element.hasAttribute('target')) element.removeAttribute('target');
} else if (!element.dataset.ssQuoteAction) {
element.dataset.ssQuoteAction = 'true';
element.addEventListener('click', event => { event.preventDefault(); event.stopImmediatePropagation(); window.location.assign(quotePath); }, true);
}
if (label !== 'Get a Quote') {
if (element.matches('input')) element.value = 'Get a Quote';
else {
const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
const nodes = [];
while (walker.nextNode()) if (walker.currentNode.nodeValue.trim()) nodes.push(walker.currentNode);
if (nodes.length) { nodes[0].nodeValue = 'Get a Quote'; nodes.slice(1).forEach(node => { node.nodeValue = ''; }); }
}
if (element.hasAttribute('aria-label')) element.setAttribute('aria-label', 'Get a Quote');
}
});
}
updateQuoteButtons();
let queued = false;
new MutationObserver(() => {
if (queued) return;
queued = true;
requestAnimationFrame(() => { queued = false; updateQuoteButtons(); });
}).observe(document.body, { childList: true, subtree: true });
})();